"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Icon;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@mui/styles");
var _icons = _interopRequireDefault(require("./icons"));
require("./styles.scss");
const useStyles = (0, _styles.makeStyles)(() => ({
  icon: {
    '& path': {
      fill: props => props.fillColor
    }
  }
}));
function Icon(_ref) {
  let {
    size = 'small',
    name,
    className,
    fillColor,
    style
  } = _ref;
  const classes = useStyles({
    fillColor
  });
  const SVGComponent = _icons.default[name];
  return /*#__PURE__*/_react.default.createElement(SVGComponent, {
    className: "tw-icon tw-icon--".concat(size, " ").concat(className !== null && className !== void 0 ? className : '', " ").concat(fillColor ? classes.icon : ''),
    style: style
  });
}